// @flow

import {buildAdlFragmentFromParams} from '../components/AnalyticsDataLayer/buildAnalyticsDataLayer';

import type {SearchRequestQueryStartAction} from '../actions/searchRequestQuery';
import type {Store} from '../reducers';

export const updateAdlFromSearchParams = (
    store: Store,
    searchRequestQueryStartAction: SearchRequestQueryStartAction
) => {
    let prevFilterGroups;

    if (searchRequestQueryStartAction) {
        const {
            prevData: {results: prevResults}
        } = searchRequestQueryStartAction.payload;

        prevFilterGroups = prevResults && prevResults.filterGroups;
    }

    const updateForAdl = buildAdlFragmentFromParams(store, prevFilterGroups);

    window.analyticsdatalayer = {
        ...window.analyticsdatalayer,
        ...updateForAdl
    };
};
